export enum PaymentTypeEnum {
    CREDIT_CARD="CREDIT_CARD",
    //GOOGLE_PAY ="GOOGLE_PAY",
    //APLLE_PAY ="APLLE_PAY",
    BANK = "BANK",
    NONE= "NONE"
}